import { ExportRequestDetailsModalProps } from "./export-history-details-modal.types";
import ExportRequestDetailsView from "./export-request-details-view";
import { useExportRequestDetails } from "./use-export-request-details";

export default function ExportRequestDetailsModal(props: ExportRequestDetailsModalProps) {
  const logic = useExportRequestDetails({ id: props.id });
  return <ExportRequestDetailsView {...logic} {...props} />;
}
